import { axiosClient, getBaseUrlVersioned } from "../axiosClient";
import { DATABRICKS_EVENT_ENDPOINT } from "./constants";
/**
 * Sends one analytics event to the `/event` endpoint, the single Client entry to the Databricks pipeline.
 * The shared axios client adds the application headers the Server reads to fill the event schema.
 * Rejects on failure so each caller decides whether a lost event matters.
 */
export default async function sendEvent({ eventName, fields = {} }) {
    const response = await axiosClient.post(`${getBaseUrlVersioned(null)}/${DATABRICKS_EVENT_ENDPOINT}`, {
        event_name: eventName,
        ...fields,
    });
    return response.data;
}
